// src/pages/talleres/editar/ModalidadesForm.jsx
import React from 'react';
import { Form, Switch, Card, Alert, Divider, Checkbox } from 'antd';
import { GiftOutlined, DollarOutlined, UserDeleteOutlined, WarningOutlined } from '@ant-design/icons';
import ModalidadesPago from './ModalidadesPago';
import dayjs from 'dayjs';

export default function ModalidadesForm({ 
  form, 
  planActive, 
  setPlanActive, 
  esGratuito, 
  setEsGratuito,
  disabled = false,
  fechasActividades = null // 🆕 Recibir como prop
}) {
  const watchLiberarCupos = Form.useWatch('liberarCuposPorBaja', form);

  // 🆕 Calcular duración y planes permitidos usando el prop
  let diasTotales = null;
  let duracionMeses = null;
  let planesPermitidos = ['mensual', 'trimestral', 'semestral', 'anual'];

  if (fechasActividades && fechasActividades[0] && fechasActividades[1]) {
    const inicio = dayjs(fechasActividades[0]);
    const fin = dayjs(fechasActividades[1]);
    diasTotales = fin.diff(inicio, 'day');
    duracionMeses = Math.floor(diasTotales / 30);

    // Determinar planes permitidos según duración
    planesPermitidos = ['mensual']; // Siempre permitir mensual

    if (diasTotales >= 90) planesPermitidos.push('trimestral');
    if (diasTotales >= 180) planesPermitidos.push('semestral');
    if (diasTotales >= 365) planesPermitidos.push('anual');
  }

  console.log('🔍 DEBUG ModalidadesForm:', {
    fechasActividades,
    diasTotales,
    planesPermitidos
  });

  return (
    <div className="space-y-4">
      {/* Alerta de restricción de planes */}
      {diasTotales !== null && diasTotales < 365 && (
        <Alert
          message="Restricción de planes por duración del taller"
          description={
            <div className="space-y-2">
              <p>
                <strong>Duración del taller: {diasTotales} días ({duracionMeses} meses aproximadamente)</strong>
              </p>
              <p>Solo podrás activar los siguientes planes:</p>
              <ul className="list-disc list-inside ml-2 mt-2">
                {planesPermitidos.includes('mensual') && <li><strong>Mensual:</strong> Disponible</li>}
                {planesPermitidos.includes('trimestral') ? (
                  <li><strong>Trimestral:</strong> Disponible (taller dura 3+ meses)</li>
                ) : (
                  <li className="text-gray-400"><strong>Trimestral:</strong> No disponible (requiere mínimo 90 días)</li>
                )}
                {planesPermitidos.includes('semestral') ? (
                  <li><strong>Semestral:</strong> Disponible (taller dura 6+ meses)</li>
                ) : (
                  <li className="text-gray-400"><strong>Semestral:</strong> No disponible (requiere mínimo 180 días)</li>
                )}
                {planesPermitidos.includes('anual') ? (
                  <li><strong>Anual:</strong> Disponible (taller dura 12+ meses)</li>
                ) : (
                  <li className="text-gray-400"><strong>Anual:</strong> No disponible (requiere mínimo 365 días)</li>
                )}
              </ul>
              <p className="mt-2 text-sm text-gray-600">
                💡 Los planes se ajustarán automáticamente a la duración real del taller
              </p>
            </div>
          }
          type="warning"
          showIcon
          icon={<WarningOutlined />}
        />
      )}

      {/* Taller gratuito */}
      <Card>
        <div className="mb-4">
          <div className="flex items-center gap-3 mb-3">
            <span className="font-medium">¿Es un taller gratuito?</span>
            <Switch 
              checked={esGratuito}
              onChange={setEsGratuito}
              checkedChildren={<><GiftOutlined /> Sí</>} 
              unCheckedChildren={<><DollarOutlined /> No</>}
              disabled={disabled}
            />
          </div>

          {esGratuito ? (
            <Alert
              message="Taller gratuito configurado"
              description="No se generarán cobros para este taller. Los usuarios podrán inscribirse sin realizar pagos."
              type="success"
              showIcon
              icon={<GiftOutlined />}
            />
          ) : (
            <>
              <Divider />
              {/* 🔥 Pasar planes permitidos calculados */}
              <ModalidadesPago 
                form={form}
                planActive={planActive}
                setPlanActive={setPlanActive}
                disabled={disabled}
                planesPermitidos={planesPermitidos}
              />
            </>
          )}
        </div>
      </Card>

      {/* Liberar cupos */}
      <Card title="Gestión de cupos">
        <Form.Item
          name="liberarCuposPorBaja"
          valuePropName="checked"
          className="mb-3"
        >
          <Checkbox disabled={disabled}>
            <UserDeleteOutlined className="mr-2" />
            Liberar cupos automáticamente cuando un usuario se dé de baja
          </Checkbox>
        </Form.Item>

        {watchLiberarCupos !== undefined && (
          <Alert
            message={watchLiberarCupos ? "Cupos se liberarán automáticamente" : "Gestión manual de cupos"}
            description={
              watchLiberarCupos 
                ? "Cuando un usuario se retire, su cupo quedará disponible inmediatamente para nuevas inscripciones"
                : "Tendrás control manual sobre la liberación de cupos cuando haya retiros"
            }
            type={watchLiberarCupos ? "success" : "info"}
            showIcon
          />
        )}
      </Card>
    </div>
  );
}
